import * as React from 'react';
import {Icon, DropdownButton} from '../util';
import AssetImportOption from './AssetImportOption';

interface AssetStatusProps {
	isPending: boolean;
	loadedOnce: boolean;
	onOpenSite(): void;
	onLoadAssets(): void;
	onModifyAssets(): void;
	onResetAssets(): void;
	onReinitializeAssets(): void;
	onExportAssets(): void;
	onImportAssets(zipFile: File): void;
}

export default class AssetStatus extends React.Component<AssetStatusProps, {}> {

	public render() {
		if (!this.props.isPending) {
			return this.renderUnmodified();
		} else if (this.props.loadedOnce) {
			return this.renderModified();
		} else {
			return this.renderNotLoaded();
		}
	}

	private renderModified() {
		return <div className='asset-status asset-status--modified'>
			<Icon name='exclamation-triangle' fixedWidth /> Your instance has pending configuration changes.
			{this.renderAssetRightButtons()}
		</div>;
	}

	private renderUnmodified() {
		return <div className='asset-status'>
			<Icon name='check-circle' fixedWidth /> Your instance is up-to-date.
			{this.renderAssetRightButtons()}
		</div>;
	}

	private renderNotLoaded() {
		return <div className='asset-status'>
			<Icon name='info-circle' fixedWidth /> Your configuration has not yet been deployed.
			{this.renderAssetRightButtons()}
		</div>;
	}

	private renderAssetRightButtons() {
		return <div className='asset-right-buttons'>
			{this.renderDeployAssetsButton()}
			{this.renderAddRemoveButton()}
			{this.renderActionsDropdown()}
		</div>;
	}

	private renderDeployAssetsButton() {
		if (this.props.isPending) {
			return <DropdownButton>
				<a
					className='more-options-button'
					onClick={this.props.onLoadAssets}
				>
					<Icon name='upload' /> Deploy Configuration
				</a>
			</DropdownButton>;
		} else {
			return null;
		}
	}

	private renderAddRemoveButton() {
		return <DropdownButton>
			<a
				className='more-options-button'
				onClick={this.props.onModifyAssets}
			>
				<Icon name='umbrella' /> Add/Remove
			</a>
		</DropdownButton>;
	}

	private renderActionsDropdown() {
		return <DropdownButton>
			<a className='more-options-button'>
				Actions <Icon name='caret-down' fixedWidth />
			</a>
			<a onClick={this.props.onExportAssets}>
				<Icon name='download' /> Save configuration to disk
			</a>
			<AssetImportOption
				onImport={this.props.onImportAssets}
			/>
			{this.renderUndoPendingChangesOption()}
			<a onClick={this.props.onReinitializeAssets}>
				<Icon name='refresh' /> Reset to default configuration
			</a>
		</DropdownButton>;
	}

	private renderUndoPendingChangesOption() {
		if (!this.props.isPending || !this.props.loadedOnce) {
			return null;
		}
		return <a onClick={this.props.onResetAssets}>
			<Icon name='undo' /> Undo pending changes
		</a>;
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/AssetStatus.tsx